import { render, staticRenderFns } from "./AddChartOfAccount.vue?vue&type=template&id=1a81297e&"
import script from "./AddChartOfAccount.vue?vue&type=script&lang=js&"
export * from "./AddChartOfAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports